import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
let list = [

  {
    path: '/home',
    name:'home',
    component: () => import( '../components/pages/home.vue'),
    meta: { title: '首页' }
  },
  
  {
    path: '/contact',
    component: () => import('../components/pages/contact.vue'),
    meta: { title: '联系我们' }
  },
  {
    path: '/about',
    component: () => import('../components/pages/about.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/project',
    component: () => import('../components/pages/project.vue'),
    meta: { title: '项目经验' }
  },
  {
    path: '/serve',
    component: () => import('../components/pages/serve.vue'),
    meta: { title: '服务内容' }
  },
  {
    path: '/news',
    component: () => import('../components/pages/news.vue'),
    meta: { title: '新闻资讯' }
  },
  {
    path: '/partners',
    component: () => import('../components/pages/partners.vue'),
    meta: { title: '合作伙伴' }
  },

];


export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/',
      component: () => import( '../components/common/warp.vue'),
      meta: { title: '首页' },
      children: list
    },


  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js